import React, { useEffect, useState } from "react"
import { DownOutlined } from '@ant-design/icons'
import { Dropdown, Space } from 'antd'
import './index.less'

const SkuListView = (props) => {
  const [defaultSelectKey, setDefaultKey] = useState([])
  const [defaultSelectValue, setDefaultValue] = useState('')
  const [items, setItems] = useState([])

  useEffect(() => { // 初始数据 
    if (props.data) {
      let items = []; 
      let main0 = {...props.data, group_products:[]}; // 外层数据提取 排除group_products
      if (props.data.group_products && props.data.group_products.length > 0) {
        let isHave = false;
        items = props.data.group_products
        .filter(item => item.InventoryQuantity > 0)
        .map(item => {
          if(item.ProductNum === main0.ProductNum) {
            isHave = true;
            setDefaultKey([item.ProductNum]);
            setDefaultValue(item.Size);
          }
          return {
            label: <span style={{color:'#6fa8a6'}} onClick={()=>{handleChangeSku(item)}}>{item.Size}</span>,
            key: item.ProductNum,
            // disabled: (!item.IsOverSaleable && item.StockLevel <= 0)
          }
        })

        if(!isHave) { // 关联数据中没有外层数据，添加进去，有就不添加
          items.unshift({
            label: <span onClick={()=>{handleChangeSku(main0)}}>{main0.Size}</span>,
            key: main0.ProductNum,
            // disabled: (!main0.IsOverSaleable && main0.StockLevel <= 0)
          })
          setDefaultKey([main0.ProductNum])
          setDefaultValue(main0.Size)
        }
        setItems(items);
      } else {
        if (items.length > 1) {
          setDefaultKey([main0.ProductNum])
        }
        setDefaultValue(main0.Size)
      }
    }
  }, [props.data])

  const handleChangeSku = (item) => {
    if(defaultSelectKey.length > 0 && defaultSelectKey[0] && item.ProductNum === defaultSelectKey[0]) {
      return
    }
    setDefaultKey([item.ProductNum])
    setDefaultValue(item.Size)
    props.changeSku({...item, group_products: []});
  }

  return(
    <Dropdown
      menu={{
        items,
        selectable: true,
        defaultSelectedKeys: defaultSelectKey,
      }}
      trigger={['click']}
    >
      <Space style={{color:'#6fa8a6', fontSize: '16px'}}>
        {defaultSelectValue}
        {items && items.length > 1 && <DownOutlined />}
      </Space>
    </Dropdown>
  )
}

export default SkuListView;
